import "./loginAuth.css";

export default function TerminalWordmark({ children }) {
  return (
    <h1 className="mgr-terminal-wordmark" aria-label="mindGAME">
      <span className="mgr-terminal-letters" aria-hidden="true">
        {Array.from("mindGAME", (letter, index) => (
          <span className="mgr-terminal-letter" key={index} style={{ "--letter-index": index }}>{letter}</span>
        ))}
      </span>
      <span className="mgr-terminal-cursor" aria-hidden="true" />
      {children}
    </h1>
  );
}
